import { arrayPushUnique } from '../../../../core/util/array-push-unique';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';
import { FormManagerPageReducerHelper } from '../form-manager-page.reducer-helper';

export const formCreateReducer = (
    state = initialState,
    action: actions.FormCreate
): State => {
    if (state.form.ids.find(id => id === action.payload.form.id)) {
        return state;
    }

    return {
        ...state,
        dirty: true,
        dirtyIds: {
            ...state.dirtyIds,
            forms: arrayPushUnique(state.dirtyIds.forms, action.payload.form.id)
        },
        form: {
            ...state.form,
            ids: [...state.form.ids, action.payload.form.id],
            entities: {
                ...state.form.entities,
                [action.payload.form.id]: action.payload.form
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/form-create.reducer.ts